/* eslint-disable */
import axios from "axios";
import { AppUrl } from "@/assets/js/variables";

const state = {
  reconst_store: {
    conflict_table_data: {},
    linked_clients: [],
  },
  pr_type: "",
  existProducts: [],
  newToAdd: {},
  myProductId: 0, //productid for add url
  DetailsShow: true,
  newProductShow: false,
  productClients: [],
  ConUrl: [],
  RCurlbool: false,
  RCurlInfo: [],
  allProducts: null,
  selectedProduct: null,
  showButton: true,
  addProductUrl: false,
  validSellers: {
    addNew: false,
    items: [],
  },
  urlsContainer: {
    raw_links: [],
    invalid_sellers: [],
    invalid_duplicate: [],
    valid_sellers: [],
    product_domains: [],
    valid_domains: [],
  },
  responseValidUrls: {},
  responseInvalidUrls: {},
  urlDuplicateContainer: {
    valid_sellers: [],
    invalid_duplicate: [],
    conflict_id: null,
  },
  conflictContainer: {},
  cloneConflictContainer: {},
  validSeller: {},
  selectedFilters: {
    product: 0,
    brand: 0,
    sku: 0,
    ean: 0,
    list: "active",
  },
  selectedFiltersMove: {
    product: 0,
    brand: 0,
    sku: 0,
  },
  products: [],
  brands: [],
  skus: [],
  categories: [],
  eans: [],
  brandsMove: [],
  productsMove: [],
  skusMove: [],
  categoriesMove: [],
  eansMove: [],
  sellerInvert: false,
};

const getters = {};

const actions = {
  productApi({ }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post(AppUrl, payload)
        .then(function (response) {
          resolve(response);
        })
        .catch((err) => reject(err));
    });
  },

  deleteProductTracks({ state, commit }, payload) {
    //alert(payload.product_id)
    return new Promise((resolve) => {
      axios
        .post(AppUrl, {
          task: "deleteProductTracks",
          payload: payload,
        })
        .then(function (response) {
          resolve(response);
        })
        .catch((err) => alert(err));
    });
  },
  saveProductClient({ state, commit }, payload) {
    return new Promise((resolve) => {
      axios
        .post(AppUrl, {
          task: "addProductClient",
          payload: payload,
        })
        .then(function (response) {
          resolve(response);
        })
        .catch((err) => alert(err));
    });
  },
  AddUrlToProduct({ state, commit }, payload) {
    return new Promise((resolve) => {
      axios
        .post(AppUrl, {
          task: "addUrlProduct",
          payload: payload,
        })
        .then(function (response) {
          resolve(response);
        })
        .catch((err) => alert(err));
    });
  },
  saveNewProduct({ state, commit }, payload) {
    return new Promise((resolve) => {
      axios
        .post(AppUrl, {
          //  task: 'productUpdate',
          task: "saveNewProduct",
          payload: payload,
        })
        .then(function (response) {
          resolve(response);
        })
        .catch((err) => alert(err));
    });
  },

  loadProduct({ commit }, data) {
    return new Promise((resolve) => {
      axios
        .post(AppUrl, {
          task: "getProducts",
          payload: data,
        })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          console.log(error);
        });
    });
  },
  deleteRowOfProductList({ commit }, data) {
    return new Promise((resolve) => {
      axios
        .post(AppUrl, {
          task: "unlinkProduct",
          payload: data,
        })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          console.log(error);
        });
    });
  },
  linkOrUnlinkOfProductList({ commit }, data) {
    return new Promise((resolve) => {
      axios
        .post(AppUrl, data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          console.log(error);
        });
    });
  },
  unlinkUrl({ commit }, data) {
    return new Promise((resolve) => {
      axios
        .post(AppUrl, {
          task: "unlinkUrl",
          payload: data,
        })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          console.log(error);
        });
    });
  },
  moveLinks({ commit }, data) {
    return new Promise((resolve) => {
      axios
        .post(AppUrl, {
          task: "moveLinks",
          payload: data,
        })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          console.log(error);
        });
    });
  },
  loadProducts({ commit }, data) {
    return new Promise((resolve) => {
      axios
        .post(AppUrl, {
          task: "loadProducts",
          payload: data,
        })
        .then((response) => {
          //  console.log('myconsole',state.urlsContainer)
          resolve(response);
        })
        .catch((error) => {
          console.log(error);
        });
    });
  } /*
  getProductList({ commit }, data) {
    return new Promise((resolve) => {
      axios.post(AppUrl, {
        task: 'getProductList',
        payload: data
      }).then(response => {
        resolve(response)
      })
        .catch(error => {
          console.log(error)
        })
    })
  },*/,
  getProductList({ commit }, data) {
    return new Promise((resolve) => {
      axios
        .post(AppUrl, {
          task: "getProductList",
          payload: data,
        })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          console.log(error);
        });
    });
  },
  validate({ commit }, data) {
    commit("SET_RAW_LINK", data);
    return new Promise((resolve) => {
      axios
        .post(AppUrl, {
          task: "validate_raw_links",
          payload: state.urlsContainer,
        })
        .then(({ data: { payload } = null }) => {
          console.log("validate_raw_links", payload);
          if (payload) {
            let hasInvalid = false;

            if (
              payload.invalid.duplicate_products.length ||
              payload.invalid.invalid_domains.length
            ) {
              hasInvalid = true;
            }
            if (hasInvalid == false && state.myProductId > 0) {
              //  commit('SET_VALID_URLS', payload.valid)
              //  commit('SET_URLS', payload.valid)
              // commit('SET_PRODUCT_ID',0)
              commit("NEW_ADD", payload.valid);
              console.log("additiooooon", payload.valid);
              resolve();
            } else {
              commit("SET_VALID_URLS", payload.valid);
              commit(
                "SET_INVALID_URLS",
                Object.assign({ hasInvalid }, payload.invalid)
              );
              commit("SET_URLS", payload.valid);
              console.log("Invalid urls", payload.invalid);
              console.log(payload.valid);
              resolve();
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    });
  },
  getBrands({ commit }, filter) {
    return new Promise((resolve, reject) => {
      axios
        .post(AppUrl, {
          task: "getBrand",
          payload: {
            filterTarget: "brandFilter",
            brand_name: filter.brandName,
            product_id: filter.productId,
            sku: filter.skuId !== 0 ? filter.skuId : "",
          },
        })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          resolve();
          console.log(error);
        });
    });
  },
  getProducts({ commit }, filter) {
    return new Promise((resolve, reject) => {
      axios
        .post(AppUrl, {
          task: "getProductFilter",
          payload: {
            filterTarget: "productFilter",
            product_name: filter.productName,
            brand_id: filter.brandId,
            sku: filter.skuId !== 0 ? filter.skuId : "",
          },
        })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          resolve();
          console.log(error);
        });
    });
  },
  getSkus({ commit }, filter) {
    return new Promise((resolve, reject) => {
      axios
        .post(AppUrl, {
          task: "getSku",
          payload: {
            filterTarget: "skuFilter",
            sku_value: filter.skuName,
            product_id: filter.productId,
            brand_id: filter.brandId,
            client_id: filter.clientId,
          },
        })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          resolve();
          console.log(error);
        });
    });
  },
  getProductFilter({ commit }, filter) {
    return new Promise((resolve, reject) => {
      axios
        .post(AppUrl, {
          task: "getProductFilter",
          payload: filter,
        })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          resolve();
          console.log(error);
        });
    });
  },
  addToPermaban({ commit }, obj) {
    return new Promise((resolve) => {
      axios
        .post(AppUrl, {
          task: "addToPermaban",
          payload: obj.sellerName,
        })
        .then((response) => {
          if (response.data) {
            commit("SET_DELETE_INVALID_SELLER", obj.sellerIndex);
          }
          resolve();
        })
        .catch((error) => {
          console.log(error);
        });
    });
  },
  addSeller({ commit }, obj) {
    return new Promise((resolve) => {
      axios
        .post(AppUrl, {
          task: "addSeller",
          payload: {
            seller: obj.seller,
            valid_sellers: state.urlsContainer.valid_sellers,
          },
        })
        .then((response) => {
          if (!response.data.error) {
            commit("SET_DELETE_INVALID_SELLER", obj.sellerIndex);
            commit("SET_UPDATE_VALID_SELLERS", response.data.valid_sellers);
          }
          resolve(response);
        })
        .catch((error) => {
          console.log(error);
        });
    });
  },
  conflictResolve({ commit }, productInfo) {
    commit("SET_CONFLICT_ID", productInfo.product_id);
    const body = {
      product_info: productInfo,
      valid: state.responseValidUrls,
      invalid: state.responseInvalidUrls,
    };
    return axios
      .post(AppUrl, {
        task: "conflictResolve",
        payload: body,
      })
      .then(function ({ data: { payload } }) {
        console.log("RESPONSE_CONFLICT", payload);
        commit("SET_CONFLICT_URLS", payload);
        commit("SET_CLONE_CONFLICT_URLS", payload);
        return payload;
      })
      .catch((err) => err);
  },
  extract({ state, commit }, sellerInfo) {
    commit("SET_EXTRACT_SELLER", sellerInfo);
    return new Promise((resolve, reject) => {
      axios
        .post(AppUrl, {
          task: "link_product_extract",
          payload: state.validSeller,
        })
        .then(function (response) {
          if (response.data) {
            resolve(response);
          } else {
            reject(new Error("Data is empty"));
          }
        })
        .catch((err) => reject(err));
    });
  },
  saveRawProduct({ state, commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post(AppUrl, {
          task: "productSave",
          payload: payload,
        })
        .then((response) => {
          console.log("PRODUCT SAVE", response);
          if (response.data) {
            commit("SET_UPDATE_VALID_SELLERS", []);
            commit("SET_SHOW_BUTTON", true);
          }
          resolve(response);
        })
        .catch((err) => reject(err));
    });
  },
  extractProduct({ state, commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post(AppUrl, {
          task: "productCreate",
          payload: payload,
        })
        .then(({ data }) => {
          console.log("PRODUCT CREATE", data);
          commit("SET_PRODUCT_INFO", data);
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  saveConflictUrl({ state, commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post(AppUrl, {
          //  task: 'productUpdate',
          task: "conflictSave",
          payload: payload,
        })
        .then(function (response) {
          console.log(
            "conflictSave",
            response.data.payload.valid.product_pending
          );
          let subarray = new Array();
          // if (state.responseInvalidUrls.lenght>1)

          // alert( Object.keys(state.responseInvalidUrls.duplicate_products).length)
          if (
            Object.keys(state.responseInvalidUrls.duplicate_products).length > 1
          ) {
            let oneurl = new Array();
            for (let f = 0; f < state.ConUrl.length; f++) {
              for (let a = 0; a < state.ConUrl[f].domain_urls.length; a++) {
                oneurl.push(state.ConUrl[f].domain_urls[a].url);
              }
            }

            for (var key in state.responseInvalidUrls.duplicate_products) {
              for (
                let i = 0;
                i <
                state.responseInvalidUrls.duplicate_products[key]
                  .product_domains.length;
                i++
              ) {
                for (
                  let m = 0;
                  m <
                  state.responseInvalidUrls.duplicate_products[key]
                    .product_domains[i].domain_urls.length;
                  m++
                ) {
                  if (
                    !oneurl.includes(
                      state.responseInvalidUrls.duplicate_products[key]
                        .product_domains[i].domain_urls[m].url
                    )
                  ) {
                    subarray.push({
                      value:
                        state.responseInvalidUrls.duplicate_products[key]
                          .product_domains[i].domain_urls[m].url,
                    });
                  }
                }
              }
            }
          }
          console.log("IvalidUrls", state.responseInvalidUrls);

          for (
            let i = 0;
            i < response.data.payload.valid.product_pending.length;
            i++
          ) {
            for (
              let m = 0;
              m <
              response.data.payload.valid.product_pending[i].domain_urls.length;
              m++
            ) {
              subarray.push({
                color: 0,
                size: 0,
                value:
                  response.data.payload.valid.product_pending[i].domain_urls[m]
                    .url,
              });
            }
          }

          commit("SET_URLINFO", subarray);
          commit("SET_CONFLICT_URLS", {});
          //  commit('SET_UPDATE_VALID_SELLERS', response.data.payload.valid_sellers)
          commit("SET_CONFLICT_URLS", {});
          commit("SET_CLONE_CONFLICT_URLS", {});
          resolve(response);
        })
        .catch((err) => reject(err));
    });
  },
  gettingClients({ state, commit }) {
    return new Promise((resolve, reject) => {
      axios
        .post(AppUrl, {
          task: "load_clients",
        })
        .then(function (response) {
          resolve(response);
        })
        .catch((err) => reject(err));
    });
  },
  loadSellers({ state, commit }) {
    return new Promise((resolve, reject) => {
      axios
        .post(AppUrl, {
          task: "loadSellers",
        })
        .then(function (response) {
          resolve(response.data.domains);
        })
        .catch((err) => reject(err));
    });
  },
  loadDomains({ state, commit }) {
    return new Promise((resolve, reject) => {
      axios
        .post(AppUrl, {
          task: "loadDomains",
        })
        .then(function (response) {
          console.log("test");
          resolve(response.data.domains);
        })
        .catch((err) => reject(err));
    });
  },
  gettingVariations({ state, commit }) {
    return new Promise((resolve, reject) => {
      axios
        .post(AppUrl, {
          task: "load_variations",
        })
        .then(function (response) {
          resolve(response);
        })
        .catch((err) => reject(err));
    });
  },
  moveUrl({ commit }, newMergeContainer) {
    commit("SET_MOVE_URLS", newMergeContainer);
  },
  deleteUrl({ commit }, newMergeContainer) {
    commit("SET_DELETE_URLS", newMergeContainer);
  },
  deleteResolvedProduct({ commit }, elemIndex) {
    commit("SET_DELETE_RESOLVED_PROD", elemIndex);
  },
};

const mutations = {
  // SET_LINKED_CLIENTS(state, data) {
  //   // this.$store.state.productModule.conflictContainer.clients.length
  //   if(data.link_status){
  //     state.conflictContainer.clients.push(data.client_name);
  //   }else{
  //     state.conflictContainer.clients = state.conflictContainer.clients.filter(el => el != data.client_name);
  //   }
  // },
  SET_PRODUCT_CLIENT(state, data) {
    state.productClients.splice(data, 1);
  },
  SET_PR_TYPE(state, data) {
    state.pr_type = data;
  },
  SET_EXIST_PRODUCT(state, data) {
    state.existProducts = data;
  },
  NEW_ADD(state, data) {
    state.newToAdd = data;
  },

  SET_PRODUCT_ID(state, data) {
    state.myProductId = data;
  },
  SET_SHOW(state, data) {
    state.DetailsShow = data;
  },

  ADD_NAME(state, data) {
    state.urlsContainer.product_info.product_name = data;
  },
  ADD_BRAND(state, data) {
    state.urlsContainer.product_info.product_brand.name = data;
    state.urlsContainer.product_info.product_brand.id = "";
  },
  SET_VISIBLE(state, data) {
    state.newProductShow = data;
  },
  ADD_PRODUCT_CLIENT(state, data) {
    const searchIndex = data.findIndex((thevalue) => thevalue.value == 0);
    // console.log('clients',data)
    // alert(searchIndex)
    if (searchIndex >= 0) state.productClients = [];
    else state.productClients = data;
  },

  ADD_URL_PRODUCT(state, data) {
    for (let i = 0; i < data.product_domains.length; i++) {
      const domainIdIndex = state.urlsContainer.product_domains.findIndex(
        (item) => item.domain_id === data.product_domains[i].domain_id
      );

      //alert(domainIdIndex)
    }

    console.log("I am here", data);
    console.log("second", state.urlsContainer);
  },
  SET_CONFLICT_URL(state, data) {
    state.ConUrl = data;
  },
  SET_URLSET(state, data) {
    state.RCurlbool = data;
  },
  SET_URLINFO(state, data) {
    state.RCurlInfo = data;
  },
  SET_RAW_LINK(state, data) {
    state.urlsContainer.raw_links = data;
    // state.urlsContainer.raw_links.push(data)
  },
  SET_VALID_URLS(state, data) {
    state.responseValidUrls = data;
  },
  SET_INVALID_URLS(state, data) {
    state.responseInvalidUrls = data;
  },
  SET_VALID_LINK(state, data) {
    Object.assign(state.urlsContainer, data);
    state.validSellers.items = data;
  },
  SET_DUPLICATE_URL(state, data) {
    state.urlDuplicateContainer.valid_sellers = data.valid_sellers;
    state.urlDuplicateContainer.invalid_duplicate = data.invalid_duplicate;
  },
  SET_CONFLICT_ID(state, id) {
    state.urlDuplicateContainer.conflict_id = id;
  },
  SET_DELETE_RESOLVED_PROD(state, elemIndex) {
    state.urlsContainer.invalid_duplicate.splice(elemIndex, 1);
  },
  SET_DELETE_INVALID_SELLER(state, elemIndex) {
    state.urlsContainer.invalid_sellers.splice(elemIndex, 1);
  },
  SET_SELECTED_COLOR_ID(state, obj) {
    state.urlsContainer.valid_sellers[obj.sellerIndex].links[
      obj.linkIndex
    ].variationSelected.color = obj.selectedColorId;
  },
  SET_SELECTED_SIZE_ID(state, obj) {
    state.urlsContainer.valid_sellers[obj.sellerIndex].links[
      obj.linkIndex
    ].variationSelected.size = obj.selectedSizeId;
  },
  SET_URLS(state, data) {
    state.urlsContainer = data;
  },
  SET_PRODUCT_INFO(state, data) {
    console.log(state.urlsContainer, "ddddddddddddd");
    state.urlsContainer.product_info = data;
  },
  SET_EXTRACT_SELLER(state, data) {
    state.validSeller = Object.assign({}, state.validSeller, data);
  },
  SET_UPDATE_VALID_SELLERS(state, data) {
    state.urlsContainer.valid_sellers = data;
  },
  SET_UPDATE_INVALID_DUPLICATE(state, data) {
    state.urlsContainer.invalid_duplicate = data;
  },
  SET_CONFLICT_URLS(state, data) {
    state.conflictContainer = data;
  },
  SET_CLONE_CONFLICT_URLS(state, data) {
    state.cloneConflictContainer = data;
  },
  SET_MOVE_URLS(state, data) {
    state.conflictContainer.mergeContainer = data;
  },
  SET_DELETE_URLS(state, data) {
    state.conflictContainer.mergeContainer = data;
  },
  SET_SHOW_BUTTON(state, data) {
    state.showButton = data;
  },
  SET_ADD_PRODUCT_URL(state, data) {
    state.addProductUrl = data;
  },
  SET_PRODUCTS(state, data) {
    state.products = data;
  },
  SET_PRODUCTS_MOVE(state, data) {
    state.productsMove = data;
  },
  SET_BRANDS(state, data) {
    state.brands = data;
  },
  SET_CATEGORIES(state, data) {
    state.categories = data;
  },
  SET_CATEGORIES_MOVE(state, data) {
    state.categoriesMove = data;
  },
  SET_BRANDS_MOVE(state, data) {
    state.brandsMove = data;
  },
  SET_SKUS(state, data) {
    state.skus = data;
  },
  SET_SKUS_MOVE(state, data) {
    state.skusMove = data;
  },
  SET_EANS(state, data) {
    state.eans = data;
  },
  SET_EANS_MOVE(state, data) {
    state.eansMove = data;
  },
  SET_selectedFilters(state, data) {
    state.selectedFilters[data.key] = data.value;
  },

  SET_selectedFiltersMove(state, data) {
    state.selectedFiltersMove[data.key] = data.value;
  },
  RESET_selectedFilters(state) {
    let obj = state.selectedFilters;
    for (let key in obj) {
      obj[key] = 0;
      if (key === "date") {
        obj[key] = 1;
      }
    }
    state.selectedFilters = obj;
  },
  RESET_currentFilter(state, data) {
    let obj = state.selectedFilters;
    obj[data.key] = 0;
    if (data.key === "data") {
      obj[data.key] = 1;
    }
    state.selectedFilters = obj;
  },
  SET_sellerInvert({ sellerInvert }, data) {
    sellerInvert = data.value;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/product.js